<template>
  <footer class="site-footer">
    <div class="site-footer__top">
      <div class="site-footer__container">
        <div class="site-footer__line site-footer__line--top">
          <div class="site-footer__row">
            <div class="col-md col-lg-5">
              <h4 class="site-footer__title">
                Правительство
                <br />Камчатского края
              </h4>
              <div class="site-footer__item">
                <h5 class="site-footer__subtitle">Канцелярия</h5>
                <a class="site-footer__phone" href="tel:+74152412853">8 (4152) 41-28-53</a>
              </div>
              <div class="site-footer__item">
                <h5 class="site-footer__subtitle">Приемная</h5>
                <a class="site-footer__phone" href="tel:+7415412091">8 (4152) 41-20-91</a>
              </div>
              <div class="site-footer__item">
                <a class="site-footer__email" href="mailto:41region@kamgov.ru">41region@kamgov.ru</a>
              </div>
            </div>

            <div class="col-md-4" v-if="!isMobile">
              <div class="site-footer__nav">
                <a class="site-footer__link" href="http://www.kamgov.ru/charter">Устав Камчатского края</a>
                <a class="site-footer__link" href="http://www.kamgov.ru/anti-corruption">Противодействие коррупции</a>
                <a class="site-footer__link" href="http://www.kamgov.ru/symbolics">Символика</a>
                <a class="site-footer__link" href="http://www.kamgov.ru/perecen-ucrezdennyh-smi">Для СМИ</a>
                <a class="site-footer__link" href="http://www.kamgov.ru/links">Полезные ссылки</a>
                <a class="site-footer__link" href="http://www.kamgov.ru/provision">Положение о сайте</a>
              </div>
            </div>
            <div class="col-md-3" v-if="!isMobile">
              <div class="site-footer__info">
                <a class="site-footer__email" href="mailto:press@kamgov.ru">press@kamgov.ru</a>

                <spacecrabs class="site-footer__spacecrabs" />
              </div>
            </div>
          </div>
        </div>
        <div class="site-footer__line site-footer__line--end">
          <reference-link class="site-footer__reference" />

          <div class="site-footer__copyright">
            Запрещено любое использование материалов сайтов без письменного согласия авторов.
          </div>
        </div>
      </div>
    </div>
    <div class="site-footer__end" v-if="isMobile">
      <div class="site-footer__container">
        <spacecrabs class="site-footer__spacecrabs" />
      </div>
    </div>
  </footer>
</template>

<script>
import ReferenceLink from './ReferenceLink'
import Spacecrabs from './Spacecrabs'

export default {
  components: {
    Spacecrabs,
    ReferenceLink
  },
  computed: {
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.md)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  font-family: $font-family-roboto;
  font-weight: 300;
  position: relative;

  &__top {
    background: #e0e0e0;
  }

  &__container {
    @include make-container;

    max-width: $container-width-sm;
  }

  &__row {
    @include make-row;
  }

  &__line {
    padding: 20px 0;

    @include media-breakpoint-up(md) {
      padding: 40px 0;
    }

    & + & {
      border-top: 1px solid #C8CCD0;
    }

    &--top {
      @include media-breakpoint-down(sm) {
        @include font-size($font-size-md);
      }
    }

    &--end {
      @include media-breakpoint-down(sm) {
        @include font-size($font-size-sm);
      }
    }
  }

  &__title {
    @include font-size(22px);

    font-weight: 500;
    margin-bottom: 20px;
    line-height: $line-height-base;

    @include media-breakpoint-up(md) {
      margin-bottom: 26px;
    }
  }

  &__item {
    & + & {
      margin-top: 1rem;
    }
  }

  &__subtitle {
    @include font-size($font-size-base);
    margin-bottom: 0;
    font-weight: 300;
    line-height: 1.5;
  }

  &__phone {
    color: inherit;
  }

  &__link {
    color: $theme-black;

    &:hover {
      color: $link-hover-color;
    }
  }

  &__nav {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &__spacecrabs {
    @include media-breakpoint-down(sm) {
      padding: 10px 0;
    }
  }

  &__reference {
    display: inline-block;
    margin-bottom: 18px;

    @include media-breakpoint-up(md) {
      position: absolute;
      top: -30px;
      right: 30px;
    }
  }
}
</style>
